import codes from '@/codes';

//restful api
import { detect as wmds } from '@/service/api/wmds'

export default {
  data : () => {
    return {
      codes,
      thumbnail_size: '25%',
      confirm: false,
      add: false,
      model : {},
      url_tree : {},
      thumbnail : ''
    }
  },
  computed: {
    image() { return this.thumbnail && 'data:image/png;base64,' + this.thumbnail || ''; }
  },
  methods: {
    toggle_thumbnail() { this.thumbnail_size = this.thumbnail_size == '25%' ? '100%' : '25%'; },
    list() { this.$router.push({ name: 'wmds_detect'}); },
    async remove() {
      try {
        let rs = await wmds.deleteDetect({ id : this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh")
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }
      try{
        let rs = await wmds.detailDetect({ id : id })
        this.url_tree = (JSON.parse(rs.body.detail_data).url_tree).reverse()
        this.thumbnail = (JSON.parse(rs.body.detail_data).thumbnail)
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}